<div class="dialog-container">
  <div class="dialog-heading">
    <h2 mat-dialog-title>{{'users.createUser.heading' | translate}}</h2>
    <span class="spacer"></span>
    <div class="btn-close">
        <button mat-icon-button mat-dialog-close aria-label="Close Dialog"><mat-icon>close</mat-icon></button>
    </div>
</div>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="userDetailsForm" novalidate>
    <div class="form-wrapper">
      <div class="row">
        <div class="col-md-6">
          <div class="input-wrapper">
            <span class="input-label">
              <label>{{'users.createUser.fname' | translate}}</label><span class="required">*</span>&nbsp;&nbsp;
            </span>
            <span class="input-field">
              <input type="text" maxlength="31" class="form-control" formControlName="firstName"   (keydown.space)="$event.preventDefault()">
              <div *ngIf="f?.firstName.invalid && (f?.firstName.dirty || f?.firstName.touched)" class="alert alert-danger">
                <div *ngIf="f?.firstName.errors?.required">{{'users.createUser.fnameError1' | translate}}</div>
                <div *ngIf="f?.firstName.errors?.minlength">{{'users.createUser.fnameError2' | translate}}</div>
                <div *ngIf="f?.firstName.errors?.maxlength">{{'users.createUser.fnameError3' | translate}}</div>
                <div *ngIf="f?.firstName.errors?.pattern">{{'users.createUser.fnameError4' | translate}}</div>
              </div>
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="input-wrapper">
            <span class="input-label">
              <label>{{'users.createUser.lname' | translate}}</label><span class="required">*</span>&nbsp;&nbsp;
            </span>
            <span class="input-field">
              <input type="text" maxlength="31"  class="form-control" formControlName="lastName" (keydown.space)="$event.preventDefault()">
              <div *ngIf="f?.lastName.invalid && (f?.lastName.dirty || f?.lastName.touched)" class="alert alert-danger">
                <div *ngIf="f?.lastName.errors?.required">{{'users.createUser.lnameError1' | translate}}</div>
                <div *ngIf="f?.lastName.errors?.minlength">{{'users.createUser.lnameError2' | translate}}</div>
                <div *ngIf="f?.lastName.errors?.maxlength">{{'users.createUser.lnameError3' | translate}}</div>
                <div *ngIf="f?.lastName.errors?.pattern">{{'users.createUser.lnameError4' | translate}}</div>
              </div>
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="input-wrapper">
            <span class="input-label">
              <label>{{'users.createUser.phone' | translate}}</label><span class="required">*</span>&nbsp;&nbsp;
            </span>
            <span class="input-field">
              <input type="text" maxlength="25"  class="form-control" formControlName="phone" (keydown)="onKeydown($event)" onkeypress='return event.charCode>-48 && event.charCode<=57' (keydown.space)="$event.preventDefault()"
              (blur)="onClickOutside(true, 'phone')" (click)="onClickOutside(false, 'phone')">
              <div *ngIf="f?.phone.invalid && (f?.phone.dirty || f?.phone.touched)" class="alert alert-danger">
                <div *ngIf="f?.phone.errors?.required">{{'users.createUser.phoneError1' | translate}}</div>
                <div *ngIf="f?.phone.errors?.minlength">{{'users.createUser.phoneError2' | translate}}</div>
                <div *ngIf="f?.phone.errors?.maxlength">{{'users.createUser.phoneError3' | translate}}</div>
                <div *ngIf="f?.phone.errors?.pattern?.requiredPattern">{{'users.createUser.phoneError4' | translate}}</div>
              </div>
            </span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="input-wrapper">
            <span class="input-label">
              <label>{{'users.createUser.email' | translate}}</label><span class="required">*</span>
            </span>
            <span class="input-field">
              <input type="email" maxlength="125" class="form-control" formControlName="emailId" (keydown.space)="$event.preventDefault()"
              (blur)="onClickOutside(true, 'email')" (click)="onClickOutside(false, 'email')">
              <div *ngIf="f?.emailId.invalid && (f?.emailId.touched || f?.emailId.dirty)" class="alert alert-danger">
                <div *ngIf="f?.emailId.errors?.required">{{'users.createUser.emailError1' | translate}}</div>
                <div *ngIf="f?.emailId.errors?.minlength">{{'users.createUser.emailError2' | translate}}</div>
                <div *ngIf="f?.emailId.errors?.maxlength">{{'users.createUser.emailError3' | translate}}</div>
                <div *ngIf="f?.emailId.errors?.pattern">{{'users.createUser.emailError4' | translate}}</div>
              </div>
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="input-wrapper">
            <span class="input-label">
              <label>{{'users.createUser.password' | translate}}</label><span class="required">*</span>
            </span>
            <span class="input-field">
              <input type="password" maxlength="21" class="form-control" formControlName="password" (keydown.space)="$event.preventDefault()">
              <div *ngIf="f?.password.invalid && (f?.password.dirty || f?.password.touched)" class="alert alert-danger">
                <div *ngIf="f?.password.errors?.required">{{'users.createUser.passError1' | translate}}</div>
                <div
                  *ngIf="f?.password.errors?.maxlength ||
                  f?.password.errors?.pattern ||
                  f?.password.errors?.minlength ||
                  userDetailsForm?.get('password').hasError('passwordSameAsUsernameOrEmail')">
                  {{'users.createUser.passError2' | translate}}
                </div>
              </div>
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="input-wrapper">
            <span class="input-label">
              <label>{{'users.createUser.status.option1' | translate}}</label><span class="required">*</span>
            </span>
            <span class="input-field">
              <!-- <select class="form-control" formControlName="status">
                <option value="">Status</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select> -->
              <select aria-placeholder="Status" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="" formControlName="status">
                <option value="" ng-reflect-value="">{{'users.createUser.status.option1' | translate}}</option>
                <option *ngFor="let statusList of statusList" value="{{ statusList.id == 1 ? true : false}}">
                  {{ statusList.title }}
                </option>
            </select>
                    <div *ngIf="f?.status.invalid && (f?.status.dirty || f?.status.touched)" class="alert alert-danger">
                      <div *ngIf="f?.status.errors?.required">{{'users.createUser.statusError1' | translate}}</div>
                    </div>
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="input-wrapper">
            <span class="input-label">
              <label>{{'users.createUser.speciality' | translate}}</label><span class="required">*</span>&nbsp;&nbsp;
            </span>
            <span class="input-field">
              <input type="text" maxlength="101"  class="form-control" formControlName="speciality">
              <div *ngIf="f?.speciality.invalid && (f?.speciality.dirty || f?.speciality.touched)" class="alert alert-danger">
                <div *ngIf="f?.speciality.errors?.required">{{'users.createUser.specialityError1' | translate}}</div>
                <div *ngIf="f?.speciality.errors?.minlength">{{'users.createUser.specialityError2' | translate}}</div>
                <div *ngIf="f?.speciality.errors?.maxlength">{{'users.createUser.specialityError3' | translate}}</div>
                <div *ngIf="f?.speciality.errors?.pattern?.requiredPattern">{{'users.createUser.specialityError4' | translate}}</div>
              </div>
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="input-wrapper">
            <span class="input-label">
              <label>{{'users.createUser.center' | translate}}</label><span class="required">*</span>&nbsp;&nbsp;
            </span>
            <span class="input-field">
              <input type="text" maxlength="101"  class="form-control" formControlName="center">
              <div *ngIf="f?.center.invalid && (f?.center.dirty || f?.center.touched)" class="alert alert-danger">
                <div *ngIf="f?.center.errors?.required">{{'users.createUser.centerError1' | translate}}</div>
                <div *ngIf="f?.center.errors?.minlength">{{'users.createUser.centerError2' | translate}}</div>
                <div *ngIf="f?.center.errors?.maxlength">{{'users.createUser.centerError3' | translate}}</div>
                <div *ngIf="f?.center.errors?.pattern?.requiredPattern">{{'users.createUser.centerError4' | translate}}</div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="" class="btn-primary" aria-label="Save"
    (click)="saveUserDetails()" mat-raised-button [disabled]='userDetailsForm?.invalid'>{{'users.createUser.btnSave' | translate}}</button>
</mat-dialog-actions>
</div>


<!--
<div class="main-content-wrapper item-bank-details-container">
  <div class="content-wrapper"> -->
    <!-- <mat-tab-group>
      <mat-tab label="Add New User"> -->
    <!-- <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="filter-section">
            <button mat-raised-button (click)='navigateToUsersLanding()'>
              <i class="fa fa-angle-left"></i>
              <span> Back</span>
            </button>
          </div> -->
          <!-- <div class="title filter-section">
            <div>User Details</div>
          </div> -->
          <!-- <div class="errorMsg" *ngIf="duplicateDataFlag"> -->
            <!-- <h4>{{ errorMessage }}</h4> -->
          <!-- </div>
          <div class="btn-wrapper">
            <button (click)="saveUserDetails()" mat-raised-button color="accent" class="btn-bg-color"
              [disabled]='userDetailsForm.invalid'>Save</button>
          </div>
          <div class="tabs">
            <form [formGroup]="userDetailsForm" novalidate>
              <div class="input-class">
                <label>First name<span class="red-asterisk">*</span></label>
                <input type="text" maxlength="31" class="form-control" formControlName="firstName">
                <div *ngIf="f.firstName.invalid && (f.firstName.dirty || f.firstName.touched)" class="alert alert-danger">
                  <div *ngIf="f.firstName.errors?.required"> First name is required. </div>
                  <div *ngIf="f.firstName.errors?.minlength"> Minimum 2 characters required. </div>
                  <div *ngIf="f.firstName.errors?.maxlength">Maximum 30 characters allowed. </div>
                  <div *ngIf="f.firstName.errors?.pattern">Special characters, numbers and blank spaces are not allowed. </div>
                </div>
              </div>
              <div class="input-class">
                <label>Last name<span class="red-asterisk">*</span></label>
                <input type="text" maxlength="31"  class="form-control" formControlName="lastName">
                <div *ngIf="f.lastName.invalid && (f.lastName.dirty || f.lastName.touched)" class="alert alert-danger">
                  <div *ngIf="f.lastName.errors?.required"> Last name is required. </div>
                  <div *ngIf="f.lastName.errors?.minlength"> Minimum 2 characters required.  </div>
                  <div *ngIf="f.lastName.errors?.maxlength">Maximum 30 characters allowed.</div>
                  <div *ngIf="f.lastName.errors?.pattern">Special characters, numbers and blank spaces not allowed </div>
                </div>
              </div>
              <div class="input-class">
                <label>Phone</label>
                <input type="text" maxlength="25"  class="form-control" formControlName="phone" onkeypress='return event.charCode>-48 && event.charCode<=57'>
                <div class="col-md-12" *ngIf="f.phone.invalid && (f.phone.dirty || f.phone.touched)" class="alert alert-danger">
                  <div *ngIf="f.phone.errors?.required">Phone is reqired.</div>
                  <div *ngIf="f.phone.errors?.minlength"> Minimum 5 characters required. </div>
                  <div *ngIf="f.phone.errors?.maxlength">Maximum 24 characters allowed.</div>
                  <div *ngIf="f.phone.errors?.pattern?.requiredPattern">Phone is invalid.</div>
                </div>
              </div>
              <div class="input-class">
                <label>Email<span class="red-asterisk">*</span></label>
                <input type="text" maxlength="125" class="form-control" formControlName="emailId">
                <div class="col-md-12" *ngIf="f.emailId.invalid && (f.emailId.touched || f.emailId.dirty)" class="alert alert-danger">
                  <div *ngIf="f.emailId.errors?.required">Email is required.</div>
                  <div *ngIf="f.emailId.errors?.minlength"> Minimum 7 characters required.</div>
                  <div *ngIf="f.emailId.errors?.maxlength">Maximum 124 characters allowed.</div>
                  <div *ngIf="f.emailId.errors?.pattern">Email is invalid.</div>
                </div>
              </div>
              <div class="input-class">
                <label>Password<span class="red-asterisk">*</span></label>
                <input type="password" maxlength="21" class="form-control" formControlName="password">
                <div *ngIf="f.password.invalid && (f.password.dirty || f.password.touched)"
                  class="alert alert-danger">
                  <div *ngIf="f.password.errors?.required">Password is required. </div>
                  <!-- <div *ngIf="f.password.errors?.minlength">Minimum 6 characters required.</div> -->
                  <!-- <div *ngIf="f.password.errors?.maxlength">Maximum 20 characters allowed. </div>
                  <div *ngIf="f.password.errors?.pattern">Password should be minimum 6 characters with at least one special character, one number, one uppercase and one lowercase letter.</div>
                </div>
              </div>
              <div class="input-class">
                <label>Status<span class="red-asterisk">*</span></label>
                <select class="form-control" formControlName="status"> -->
                  <!-- <option *ngFor="let statusList of testStatusList"
                          value="{{statusList.itemstatus}}">{{statusList.itemstatus}}</option> -->
                  <!-- <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </div>


            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
